import styled from 'styled-components';

export const FreeBadge = styled.div`
  display: inline-flex;
  align-items: center;
  background: ${({ theme }) => theme.donedeal.colors.BLACK};
  border-radius: ${({ theme }) => theme.donedeal.borderRadius.default};
  padding: ${({ theme }) => `0 ${theme.donedeal.spacing.S4}`};
  margin-right: ${({ theme }) => theme.donedeal.spacing.S2};
`;
